class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);
    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-terms-checkbox]')) this.updateTermsAcceptance(event.target);
    });
    this.addEventListener('click', (event) => {
      if (!event.target.closest('[data-cart-terms-blocker]')) return;

      event.preventDefault();
      this.showTermsError();
    });
    this.addEventListener('submit', (event) => {
      if (!event.target.matches('#CartDrawer-Form')) return;

      const checkbox = this.querySelector('[data-cart-terms-checkbox]');
      if (checkbox && !checkbox.checked) {
        event.preventDefault();
        this.showTermsError();
      }
    });
    this.setHeaderCartIconAccessibility();

    if (window.location.hash === '#cart-open') {
      setTimeout(() => this.open(undefined, false));
    }
  }

  handleHashChange() {
    if (window.location.hash === '#cart-open') {
      if (!this.classList.contains('active')) this.open(undefined, false);
    } else if (this.classList.contains('active')) {
      this.close(false);
    }
  }

  addCartHash() {
    if (window.location.hash === '#cart-open') return;

    const state = { ...(window.history.state || {}), cartDrawerOpen: true };
    window.history.pushState(state, '', `${window.location.pathname}${window.location.search}#cart-open`);
  }

  removeCartHash() {
    if (window.location.hash !== '#cart-open') return;

    if (window.history.state?.cartDrawerOpen) {
      window.history.back();
    } else {
      window.history.replaceState(
        window.history.state,
        '',
        `${window.location.pathname}${window.location.search}`
      );
    }
  }

  updateTermsAcceptance(checkbox) {
    const checkoutButton = this.querySelector('#CartDrawer-Checkout');
    const blocker = this.querySelector('[data-cart-terms-blocker]');
    const error = this.querySelector('#CartDrawer-TermsError');

    if (checkoutButton) checkoutButton.disabled = !checkbox.checked;
    if (blocker) blocker.hidden = checkbox.checked;
    if (error) error.hidden = true;

    checkbox.removeAttribute('aria-invalid');
  }

  showTermsError() {
    const checkbox = this.querySelector('[data-cart-terms-checkbox]');
    const error = this.querySelector('#CartDrawer-TermsError');

    if (!checkbox || checkbox.checked) return;

    checkbox.setAttribute('aria-invalid', 'true');
    if (error) error.hidden = false;
    checkbox.focus();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy, updateHash = true) {
    if (updateHash) this.addCartHash();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(updateHash = true) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    if (updateHash !== false) this.removeCartHash();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
